module.exports = __webpack_public_path__ + "static/media/benifits-doctor-1000.f852562b.webp";